module.exports = __webpack_public_path__ + "static/img/kanban02.6384f5e4.png";